import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import findResult from '@/utils/resultsHelper';
import { filterPermissions, permissionsByAccordionCategory } from '../helper';
import PermissionsTable from '../components/PermissionsTable';
import PermissionsContainer from '../components/PermissionsContainer';

const PermissionsAccordion = ({
  category,
  code,
  categories,
  active,
  index,
  count,
  onClick,
  title,
  filter,
  grouping,
}) => {
  const intl = useIntl();
  const filteredCategories = filter ? filterPermissions(categories, filter, grouping, intl) : categories;
  if (filteredCategories.length === 0) {
    return null;
  }

  return (
    <PermissionsContainer
      active={active}
      index={index}
      onClick={onClick}
      count={count}
      title={title}
      category={category}
      code={code}
      categories={categories}
    >
      <PermissionsTable grouping={grouping} category={category} code={code} categories={filteredCategories} />
    </PermissionsContainer>
  );
};

const mapStateToProps = ({
  roles: { roles },
}, { category, code, categories }) => {
  const item = findResult(roles, category, code);
  const accordionPermissions = [];
  categories.forEach(({ actions, name }) => {
    actions.forEach((action) => {
      accordionPermissions.push({ category: name, action: action.name });
    });
  });

  return ({
    filter: item.filter,
    count: permissionsByAccordionCategory(item, accordionPermissions).length,
  });
};

export default connect(mapStateToProps)(PermissionsAccordion);
